module.exports = __webpack_public_path__ + "img/news4.e19ffaf8.png";